import { DatePipe } from '@angular/common';
import { Input } from '@angular/core';
import { Output } from '@angular/core';
import { ViewChild } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { HostListener } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';

import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/components/confirmation-dialog/confirmation-dialog.service';
import { AddpartyComponent } from 'src/app/components/party/addparty/addparty.component';
import { ComponentCanDeactivate } from 'src/app/components/PendingChangesGuard';
import { AddproductComponent } from 'src/app/components/product/addproduct/addproduct.component';
import { AddrawmaterialComponent } from 'src/app/components/rawmaterial/addrawmaterial/addrawmaterial.component';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
@Component({
  selector: 'app-addlpo',
  templateUrl: './addlpo.component.html',
  styleUrls: ['./addlpo.component.css']
})
export class AddlpoComponent implements OnInit, ComponentCanDeactivate {

  @ViewChild('Selecter', { static: false }) ngselect: NgSelectComponent;

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;
  ischeck: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  isload: boolean = true;

  israwmaterialaddmode: boolean = false;
  ispartyaddmode: boolean = false;

  rtnform: string = "";
  errtxt: any = "";

  //Edit Get Values
  lpomainColl: any = [];

  lpoBO: any = {}
  partyColl: any = [];
  paymenttermsColl: any = [];
  paymentmodeColl: any = [];

  lpodetailscoll: any = [];

  ismanualclose: boolean;

  isaccountaddmode: boolean = false;


  qtytotal: number = 0;
  unitpricetotal: number = 0;
  subtotal: number = 0;
  taxtotal: number = 0;
  cgsttaxtotal: number = 0;
  sgsttaxtotal: number = 0;
  igsttaxtotal: number = 0;
  nettotal: number = 0;


  discounttype: string = "";

  productfindColl: any;
  taxColl: any;
  rawmaterialColl: any;
  isLoadingResult: boolean;

  filterpaymentmodeid: number = 0;

  lpoform = new FormGroup({
    lpoid: new FormControl(0),
    lpono: new FormControl('', Validators.required),
    lpodate: new FormControl(null, Validators.required),
    refno: new FormControl(''),
    itmtotal: new FormControl(null),
    taxamt: new FormControl(null),
    discamt: new FormControl(null),
    discrate: new FormControl(null),
    roundoff: new FormControl(null),
    grandtotal: new FormControl(null),
    descr: new FormControl(''),
    partyid: new FormControl(null, Validators.required),
    paymentmodeid: new FormControl(null, Validators.required),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Lpo";

  gridfocusrow: number = -1;

  @Input() lpoid: number = 0
  @Input() filterpartyid: number = null;
  @Input() filterfromdate: any = null;
  @Input() filtertodate: any = null;
  @Input() ptype: String = "S";
  @Input() formmode: String = "";

  currencyMask:any="";

  @Output() emitData = new EventEmitter();

  constructor(private appService: DhukanDataService, private activeModal: NgbActiveModal, private route: ActivatedRoute,
    private productFindService: NgbModal, private confirmationDialogService: ConfirmationDialogService,
    public router: Router, private toastr: ToastrService, public loginService: LoginDataService, private datePipe: DatePipe) {

    this.fnServiceChanges();

    this.currencyMask=this.loginService.fngetDecimalPlaces()
  }


  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }

        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.lpoform.reset();
      this.fnInitializeForm();

      if (this.lpoid > 0) {
        this.fngetLpo();
      }
      else {
        this.fnSetFirstRowItem()
      }
      this.fngetPaymentMode()
      this.fngetParty();
      this.fnGetRawmaterial();
      this.fnGetTax();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit() {
    //  this.loginService.fnSetFirstControlFocusLookup(this.ngselect);


  }




  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.lpoid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }
    this.israwmaterialaddmode = this.loginService.fnCheckUserRoleAction("Rawmaterial", 'CREATE')
    this.ispartyaddmode = this.loginService.fnCheckUserRoleAction("Supplier", 'CREATE')

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeForm() {
    this.lpoform.setValue({
      lpoid: 0,
      lpono: 'NEW',
      lpodate: new Date(),
      itmtotal: null,
      taxamt: null,
      discamt: null,
      discrate: null,
      roundoff: null,
      grandtotal: null,
      descr: null,
      partyid: null,
      paymentmodeid:null,
      refno: '',
      inactive: false,
    })
  }



  fngetParty() {
    var data = {
      'partyid': 0,
      'ptype': this.ptype,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getParty(data)
      .subscribe(
        (res) => {
          this.partyColl = res.json().result;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fngetPaymentMode() {
    var data = {
      'paymentmodeid': 0,      
    }
    this.appService.getPaymentmodeTransaction(data)
      .subscribe(
        (res) => {
          this.paymentmodeColl = res.json().result;

          if (this.lpoid == 0) {
            for (let abo of this.paymentmodeColl) {
              if (abo.paymentmodelist === 'CREDIT') {
                this.lpoform.patchValue({ 'paymentmodeid': abo.paymentmodeid })
              }
            }
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }



  //Get 
  fngetLpo() {

    var data = {
      'lpoid': this.lpoid,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getLpo(data)
      .subscribe(
        (res) => {
          var result = res.json().result;

          this.lpomainColl = result[0];

          var editdata = this.lpomainColl[0];
          this.lpoBO = editdata;
          this.fnEditMode(editdata);

          this.lpodetailscoll = result[1];
          //console.log(this.lpodetailscoll)

          if (this.lpodetailscoll.length === 0) {
            this.fnSetFirstRowItem()
          }
          this.fnCalcDetails();
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnValidation() {
    var _ischeck = false;
    var _detailscheck = false;

    for (let row of this.lpodetailscoll) {
      if (row.rawmaterialid > 0) {
        _detailscheck = true;
      }
    }

    if (!_detailscheck) {
      this.errtxt = "lpo Details cannot be empty"
      this.lpoform.controls['inactive'].setErrors({ 'notfound': true });
      _ischeck = true;
    }
    if (!_ischeck) {
      for (let row of this.lpodetailscoll) {

        if (row.rawmaterialid > 0 && this.loginService.fnCheckZeroDetcimal(row.qty) === 0) {
          this.errtxt = "Quantity is cannot be empty"
          this.lpoform.controls['inactive'].setErrors({ 'notfound': true });
          _ischeck = true;
        }

      }
    }
    return _ischeck;

  }

  fnResetValidation() {

    if (this.lpoform.get('inactive')) {
      this.lpoform.controls['inactive'].setErrors(null);
    }

  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;

      this.fnResetValidation()
      //Validate

      if (this.lpoform.valid) {

        if (this.fnValidation()) {

          return false
        }


        this.saveloading = true;



        //Check
        var data = {
          'lpoid': this.lpoid,
          'lpono': this.lpoform.get('lpono').value,
          'lpodate': this.fnFormatDatetime(this.lpoform.get('lpodate').value),
          'itmtotal': this.lpoform.get('itmtotal').value,
          'taxamt': this.lpoform.get('taxamt').value,
          'discamt': this.lpoform.get('discamt').value,
          'discrate': this.lpoform.get('discrate').value,
          'roundoff': this.lpoform.get('roundoff').value,
          'grandtotal': this.lpoform.get('grandtotal').value,
          'descr': this.lpoform.get('descr').value,
          'partyid': this.lpoform.get('partyid').value,
          'refno': this.lpoform.get('refno').value,
          'paymentmodeid': this.lpoform.get('paymentmodeid').value,
          'inactive': this.lpoform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
          'lpodetailscoll': this.lpodetailscoll,
        }

        if (this.lpoform.get('lpoid').value > 0) {

          this.fnSetLpo(data);
        }
        else {

          this.fnInsertLpo(data);
        }

      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }

  }

  //Insert
  fnInsertLpo(data) {

    this.appService.fnInsertLpo(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status == 200) {
          this.toastr.success('', "The new lpo has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.lpono);

          var _result = res.json().result;
          if (_result.length > 0) {
            this.fnEditFormEdit(_result[0].lpoid);
          }

        } else {
          this.toastr.error('Error', res.json().err_message);
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetLpo(data) {

    this.appService.fnSetLpo(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status == 200) {
          this.toastr.success('', "The lpo has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.lpoid, data.lpono);

          this.fnEditFormEdit(this.lpoid);
        } else {
          this.toastr.error('Error', res.json().err_message);
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }


  private fnEditMode(deptBO) {

    deptBO.lpodate = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.lpodate));


    this.lpoform.setValue({

      lpoid: deptBO.lpoid,
      lpono: deptBO.lpono,
      lpodate: deptBO.lpodate,
      itmtotal: deptBO.itmtotal,
      taxamt: deptBO.taxamt,
      discamt: deptBO.discamt,
      discrate: deptBO.discrate,
      roundoff: deptBO.roundoff,
      grandtotal: deptBO.grandtotal,
      descr: deptBO.descr,
      partyid: deptBO.partyid,
      paymentmodeid:deptBO.paymentmodeid,
      refno: deptBO.refno,
      inactive: deptBO.inactive,

    });

    if (deptBO.discrate === 0 && deptBO.discamt > 0) {
      this.discounttype = "AMT"
    }


    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = false;

    if (this.formmode === 'EDIT') {
      this.iseditmode = true;
    }
    else {
      this.isviewmode = true;
    }
  }


  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }




  fnEditFormEdit(id) {

    this.lpoid = id;
    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;


    //this.ngOnInit();

    this.ismanualclose = true;
    this.fnCloseForm();

  }

  //Close
  async fnCloseForm() {

    try {

      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;


      this.emitData.emit("");
      this.activeModal.close(true);

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  @HostListener('window:beforeunload')
  canDeactivate(): any {

    if (this.ismanualclose || this.isviewmode) {
      return true;
    }
    else {
      return false;
    }
  }

  //Details

  fnGetRawmaterial() {
    this.isLoadingResult = true;

    var data = {
      'rawmaterialid': 0,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getRawmaterial(data)
      .subscribe(
        (res) => {
          this.rawmaterialColl = res.json().result;

          this.isLoadingResult = false;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fnReLoadRawmaterial(index) {


    var data = {
      'rawmaterialid': 0,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getRawmaterial(data)
      .subscribe(
        (res) => {
          this.fnChangeRawmaterial(index)
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnGetTax() {
    this.isLoadingResult = true;

    var data = {
      'taxid': 0,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getTax(data)
      .subscribe(
        (res) => {
          this.taxColl = res.json().result;


          this.isLoadingResult = false;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnCalcDetails() {

  
    for (let row of this.lpodetailscoll) {
      
      row.subtotal = row.qty * row.unitprice;

      //Discount

      if (this.aaNumber(row.discrate) === 0 && this.aaNumber(row.discamt) > 0) {
        row.stafterdiscamt = this.aaNumber(row.subtotal) - this.aaNumber(row.discamt)
      }
      else if (this.aaNumber(row.discrate) > 0) {
        row.discamt = this.aaNumber(row.subtotal) * this.aaNumber(row.discrate / 100)
        row.discamt = this.aaNumber(row.discamt)
        row.stafterdiscamt = row.subtotal - row.discamt
      }
      else {
        row.stafterdiscamt = row.subtotal
        row.discrate = 0
        row.discamt = 0
      }

      //TAX
      row.taxamt = row.stafterdiscamt * row.taxrate / 100

      //GST      
      row.cgsttaxamt = Number(this.fnConvertDecimal(row.taxamt)) / 2
      row.sgsttaxamt = Number(this.fnConvertDecimal(row.taxamt)) / 2
      row.igsttaxamt = 0


      row.taxable = Number(this.fnConvertDecimal(row.subtotal));


      row.nettotal = Number(this.fnConvertDecimal(row.taxable)) + Number(this.fnConvertDecimal(row.taxamt))
    }
  
 

  this.fnCalcsSummaryTotal()
}
  // fnCalcDetails() {

  //   for (let row of this.lpodetailscoll) {
  //     row.subtotal = row.qty * row.unitprice;
  //     this.subtotal = this.subtotal + Number(row.subtotal)

  //     row.taxamt = row.subtotal * row.taxrate / 100

  //     //GST      
  //     row.cgsttaxamt = Number(this.fnConvertDecimal(row.taxamt)) / 2
  //     row.sgsttaxamt = Number(this.fnConvertDecimal(row.taxamt)) / 2
  //     row.igsttaxamt = 0


  //     row.taxable = Number(this.fnConvertDecimal(row.subtotal));


  //     row.nettotal = Number(this.fnConvertDecimal(row.taxable)) + Number(this.fnConvertDecimal(row.taxamt))

  //   }
  //   this.fnCalcsSummaryTotal()
  // }




  fnCalcsSummaryTotal() {
    this.qtytotal = 0;
    this.unitpricetotal = 0;
    this.subtotal = 0;
    this.taxtotal = 0;
    this.cgsttaxtotal = 0;
    this.sgsttaxtotal = 0;
    this.igsttaxtotal = 0;
    this.nettotal = 0;


    for (let row of this.lpodetailscoll) {
      this.qtytotal = Number(this.fnConvertDecimal(this.qtytotal)) + Number(this.fnConvertDecimal(row.qty))
      this.unitpricetotal = Number(this.fnConvertDecimal(this.unitpricetotal)) + row.unitprice
      this.subtotal = Number(this.fnConvertDecimal(this.subtotal)) + row.subtotal

      this.taxtotal = Number(this.fnConvertDecimal(this.taxtotal)) + row.taxamt
      this.cgsttaxtotal = Number(this.fnConvertDecimal(this.cgsttaxtotal)) + row.cgsttaxamt
      this.sgsttaxtotal = Number(this.fnConvertDecimal(this.sgsttaxtotal)) + row.sgsttaxamt
      this.igsttaxtotal = Number(this.fnConvertDecimal(this.igsttaxtotal)) + row.igsttaxamt

      this.nettotal = Number(this.fnConvertDecimal(this.nettotal)) + row.nettotal

    }

  
   //Bill Discount
   var discrate = 0, discamt = 0;
   var billdiscamt = 0;
   discrate = this.lpoform.get("discrate").value;
   discamt = this.lpoform.get("discamt").value;


   if (this.discounttype === 'AMT') {
     discrate = 0
     this.lpoform.patchValue({ 'discrate': discrate });
     billdiscamt = Number(this.fnConvertDecimal(discamt))
   }
   else {
     billdiscamt = Number(this.fnConvertDecimal(Number(this.fnConvertDecimal(this.nettotal)) * Number(this.fnConvertDecimal(discrate)) / 100))
     this.lpoform.patchValue({ 'discamt': billdiscamt });
   }

   this.nettotal = this.nettotal - Number(this.fnConvertDecimal(billdiscamt))



    //Roundoff
    var roundoff = 0;
    roundoff = this.lpoform.get("roundoff").value;

    this.nettotal = this.nettotal + Number(this.fnConvertDecimal(roundoff))

    this.lpoform.patchValue({ itmtotal: this.subtotal })
    this.lpoform.patchValue({ taxamt: this.taxtotal })
    this.lpoform.patchValue({ grandtotal: this.nettotal })
  }




  fnDeleteLpoConfirm(index) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete details?')
        .then((confirmed) => {
          if (confirmed) {
            this.lpodetailscoll.splice(index, 1)
            if (this.lpodetailscoll.length === 0) {
              this.fnSetFirstRowItem()
            }
            this.fnCalcDetails()
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  fnChangeRawmaterial(index) {

    var _prodname = "", _uomid = null, _unitprice = 0, _taxid = null;

    for (let abo of this.rawmaterialColl) {
      if (this.lpodetailscoll[index].rawmaterialid === abo.rawmaterialid) {
        _prodname = abo.rawmaterialname;
        _unitprice = abo.lpoprice;
        _uomid = abo.uomid;
        _taxid = abo.taxid;
      }
    }
    this.lpodetailscoll[index].rawmaterialname = _prodname;
    this.lpodetailscoll[index].unitprice = _unitprice;
    this.lpodetailscoll[index].uomid = _uomid;
    this.lpodetailscoll[index].taxid = _taxid;

    this.fnChangeTax(index)
  }


  fnChangeTax(index) {

    var _taxname = "", _taxrate = 0;

    var _cgsttaxrate = 0, _sgsttaxrate = 0, _igsttaxrate = 0;

    for (let abo of this.taxColl) {
      if (this.lpodetailscoll[index].taxid === abo.taxid) {
        _taxname = abo.taxname;
        _taxrate = abo.taxrate;
        _cgsttaxrate = abo.cgsttaxrate;
        _sgsttaxrate = abo.sgsttaxrate;
        _igsttaxrate = abo.igsttaxrate;
      }
    }
    this.lpodetailscoll[index].taxname = _taxname;
    this.lpodetailscoll[index].taxrate = _taxrate;
    this.lpodetailscoll[index].cgsttaxrate = _cgsttaxrate;
    this.lpodetailscoll[index].sgsttaxrate = _sgsttaxrate;
    this.lpodetailscoll[index].igsttaxrate = _igsttaxrate;

    this.fnCalcDetails()

  }
  fnChangeDiscountType(type) {
    this.discounttype = type;

    if (this.discounttype === "AMT") {
      this.lpoform.patchValue({ 'discrate': 0 });
      this.lpoform.patchValue({ 'discamt': 0 });
      this.fnCalcDetails();
    }

  }

  fnSetFirstRowItem() {
    if (this.lpodetailscoll.length > 0) {
      if (!this.lpodetailscoll[this.lpodetailscoll.length - 1].rawmaterialid) {
        return
      }
    }

    var data = {
      lpodetailsid: 0,
      lpoid: 0,
      rawmaterialid: null,
      rawmaterialname: '',
      qty: 0,
      unitprice: 0,
      subtotal: 0,
      uomid: null,
      taxid: null,
      taxname: '',
      taxrate: 0,
      taxamt: 0,
      cgsttaxrate: 0,
      cgsttaxamt: 0,
      sgsttaxrate: 0,
      sgsttaxamt: 0,
      igsttaxrate: 0,
      igsttaxamt: 0,
    }

    this.lpodetailscoll.push(data)

  }


  fnGetFirstRowItem() {

    var data = {
      lpodetailsid:null,
      lpoid: null,
      rawmaterialid: null,
      rawmaterialname: '',
      qty: null,
      unitprice:null,
      subtotal:null,
      uomid: null,
      taxid: null,
      taxname: '',
      taxrate: null,
      taxamt: null,
      cgsttaxrate: 0,
      cgsttaxamt: 0,
      sgsttaxrate: 0,
      sgsttaxamt: 0,
      igsttaxrate: 0,
      igsttaxamt: 0,
      taxable: 0,
      nettotal:null
    }

    return data;

  }


  //Focus
  fnFocusChangeGridRow(index) {
    this.gridfocusrow = index

  }

  fnSetNextFocus(index) {

    if (this.lpodetailscoll.length > 0) {

      if (this.lpodetailscoll.length > index + 1) {
        this.gridfocusrow = index + 1
      }
    }


  }


  //AddParty
  private fnAddParty() {

    const modalRef = this.productFindService.open(AddpartyComponent, { size: <any>'xxl' });
    modalRef.componentInstance.ptype = this.ptype

    if (modalRef.componentInstance.ptype === 'C') {
      modalRef.componentInstance.formname = 'Customer'
    }
    else if (modalRef.componentInstance.ptype === 'S') {
      modalRef.componentInstance.formname = 'Supplier'
    }
    modalRef.componentInstance.ngOnInit();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetParty();

      if (receivedEntry > 0) {
        this.lpoform.patchValue({ partyid: receivedEntry })
      }
    });

  }
  //AddProduct
  private fnAddRawmaterial(index) {

    const modalRef = this.productFindService.open(AddrawmaterialComponent, { size: <any>'xxl' });
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fnGetRawmaterial();

      if (receivedEntry > 0) {
        this.lpodetailscoll[index].rawmaterialid = receivedEntry
      }
      this.fnReLoadRawmaterial(index);

    });
  }

  // fnAddlpoDetails() {

  //   const modalRef = this.productFindService.open(AddlpodetailsComponent, { size: <any>'l' });
  //   modalRef.componentInstance.lpodetailsBO=this.fnGetFirstRowItem()
  //   modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

  //     if (receivedEntry.checkstatus === "DONE") {
  //       this.fnSetFirstRowItem()
  //       this.lpodetailscoll[this.lpodetailscoll.length - 1] = receivedEntry.data;
  //       this.fnCalcDetails()
  //     }

  //   });
  // }

  // private fnEditlpoDetails(index) {

  //   const modalRef = this.productFindService.open(AddlpodetailsComponent, { size: <any>'l' });
  //   modalRef.componentInstance.lpodetailsBO = this.lpodetailscoll[index];
  //   modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

  //     if (receivedEntry.checkstatus === "DONE") {        
  //       this.lpodetailscoll[index] = receivedEntry.data;
  //       this.fnCalcDetails()
  //     }


  //   });
  // }





  //Print
  // private fnPrintlpo() {

  //   const modalRef = this.productFindService.open(PrintComponent, { size: <any>'l', backdrop: 'static' });
  //   modalRef.componentInstance.trxid = this.lpoid;
  //   modalRef.componentInstance.doctype = this.formname;

  //   modalRef.componentInstance.emitData.subscribe((receivedEntry) => {



  //   });

  // }
  //Print
  // private fnGldetails() {

  //   const modalRef = this.productFindService.open(GldetailscommonComponent, { size: <any>'l', backdrop: 'static' });
  //   modalRef.componentInstance.trxid = this.lpoid;
  //   modalRef.componentInstance.doctype = this.formname;

  //   modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

  //   });

  // }

  

  fnPostingConfirm(type) {
    this.confirmationDialogService.confirm('Confirm..', 'Do you  want to ' + type + ' lpo?')
      .then((confirmed) => {
        if (confirmed) {
          if (type === 'Post') {
            this.fnPosting()
          }
          else if (type === 'UnPost') {
            this.fnUnPosting()
          }

        }
      }
      );
  }


  fnPosting() {
    var data = {
      trxid: this.lpoid,
      doctype: 'LPO',
      postingtype: 'MANUAL',
      modifiedby: this.loginService.fnGetModUserId()

    }
    this.appService.fnInsertPostings(data)
      .subscribe(
        (res) => {
         
          if (res.json().status === 200) {
        
            this.fnEditFormEdit(this.lpoid);
          }
          else {
            this.toastr.error('Error', res.json().err_message);
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnUnPosting() {
    var data = {
      trxid: this.lpoid,
      doctype: 'LPO',
      postingtype: 'MANUAL',
      modifiedby: this.loginService.fnGetModUserId()

    }
    this.appService.fnInsertUnPostings(data)
      .subscribe(
        (res) => {
          
          if (res.json().status === 200) {
          
            var result=res.json().result;
           
            if(result.length>0){
         
              if(result[0].checkresult==='DONE'){
                this.fnEditFormEdit(this.lpoid);
              }
              else{
                this.toastr.error('Error', result[0].checkresultmsg);
              }
            }
           
          }
          else {
            this.toastr.error('Error', res.json().err_message);
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  
  fnEnableEditBtn() {
    if(this.lpoBO.iscancelled===1){
      return false;
    }
    else if (this.lpoBO.isposted === 1) {
      return false;
    }
    else {
      return true;
    }
  }

  fnEnablePostBtn() {
    if(this.lpoBO.iscancelled===1){
      return false;
    }
    else  if (this.lpoBO.isposted === 1) {
      return false;
    }
    else {
      return true;
    }
  }


  
  fnEnableUnPostBtn() {
    if (this.lpoBO.isposted === 1) {
      return true;
    }
    else {
      return false;
    }
    
  }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId()

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  aaNumber(total) {

    if (isNaN(total) || total === undefined || total === null) {
      return Number(0)
    }
    else {
      return Number.parseFloat(Number(total).toFixed(2))
    }
  }
  fnConvertDecimal(value) {
    if (!value) {
      return 0
    }
    else {
      return value
    }

  }


  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }




  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }






}
